import 'axios';
import appConfig from '../../config';
import { appEvents } from '../../services';
import { httpClient } from '../../utils/http-client';
import { logError } from '../../utils/logs';
export class EncoderClient {
    client;
    _onComplete;
    _onProgress;
    _onBegin;
    _onCapturEnd;
    _onError;
    _onDisconnected;
    constructor() {
        const baseURL = appConfig.encoderApiUrl;
        if (!baseURL)
            throw new Error('Encoder API URL is not defined');
        this.client = httpClient; // This might change in the future.
        this.setupInternalEventListeners();
    }
    onComplete(event) {
        if (encoderClient._onComplete)
            encoderClient._onComplete(event);
    }
    onProgress(event) {
        if (encoderClient._onProgress)
            encoderClient._onProgress(event.eventData);
    }
    onBegin(event) {
        if (encoderClient._onBegin)
            encoderClient._onBegin(event);
    }
    onCapturEnd(event) {
        if (encoderClient._onCapturEnd)
            encoderClient._onCapturEnd(event);
    }
    onError(event) {
        logError('[brush-encoder-error]', event);
        if (encoderClient._onCapturEnd)
            encoderClient._onCapturEnd(event);
    }
    onDisconnected(event) {
        console.warn('Encoder disconnected while waiting in queue');
        if (encoderClient._onDisconnected)
            encoderClient._onDisconnected(event);
    }
    setupEventListeners(eventListeners) {
        this._onComplete = eventListeners.onComplete;
        this._onProgress = eventListeners.onProgress;
        this._onBegin = eventListeners.onBegin;
        this._onCapturEnd = eventListeners.onCapturEnd;
        this._onDisconnected = eventListeners.onDisconnected;
        this._onError = eventListeners.onError;
        return this;
    }
    setupInternalEventListeners() {
        appEvents.on('encoder-complete', this.onComplete);
        appEvents.on('encoder-progress', this.onProgress);
        appEvents.on('encoder-start', this.onBegin);
        appEvents.on('encoder-process-restart', this.onDisconnected);
        appEvents.on('encoder-capture-end', this.onCapturEnd);
        appEvents.on('encoder-error', this.onError);
    }
    async queueVideo(videoData) {
        if (videoData.videoData.duration > 60 * 2.5)
            throw new Error('Video Duration exceeds maximum');
        await this.client.post('/render', videoData);
    }
}
const encoderClient = new EncoderClient();
export default encoderClient;
